import { useState, useEffect } from "react";
import { DEFAULT_LOCALE } from "../config";
import { localeService } from "../dependencyInjection";
import { unsubscribe } from "../../../utils";
import { Subscription } from "rxjs";

export function useLocale() {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);
  const [currentTranslations, setCurrentTranslations] = useState({});

  useEffect(() => {
    let subLocale = new Subscription();
    let subTranslations = new Subscription();

    if (!localeService.locale) {
      subLocale = localeService.subscribeLocale(setLocale);
      subTranslations = localeService.subscribeTranslations(setCurrentTranslations);
      localeService.initLocale(DEFAULT_LOCALE);
    } else {
      setLocale(localeService.locale);
      setCurrentTranslations(localeService.currentTranslations);
    }

    return unsubscribe(subLocale, subTranslations);
  }, []);

  return { locale, currentTranslations };
}
